import { useEffect, useRef, useState } from 'react'
import { Redirect } from 'react-router'
import styled from 'styled-components'
import { useGeneralContext } from './contexts/GeneralContext'
import { navDirections } from './utils/navDirections'
import Vimeo from '@u-wave/react-vimeo'
import { REAL_DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'
import ZoomingAnimation from './partials/ZoomingAnimation'
import ProgressBarVideo from './partials/ProgressBarVideo'

function OnlineClassYtVideo() {
    const { chapterSelected, subSelected, partSelected } = useGeneralContext()
    const { userDetails } = useAuthContext()
    const [percentageViewed, setPercentageViewed] = useState(-1)

    const [ready, setReady] = useState(false)
    const [loading, setLoading] = useState(true)
    const [paused, setPaused] = useState(false)
    const timeSpentRef = useRef([])
    const calcPercentRef = useRef(0)
    const lastSecondRef = useRef(-1)
    const lastPercent = useRef(-1)

    function setDataToDB() {
        if (
            calcPercentRef.current < percentageViewed ||
            !!!userDetails?.name ||
            !!!userDetails?.rollNo ||
            !!!userDetails?.uid ||
            !!!partSelected?.id
        )
            return

        let updates = {
            videoTimeChart: JSON.stringify(timeSpentRef.current),
            percentage: calcPercentRef.current,
            name: userDetails?.name,
            rollNo: userDetails?.rollNo
        }

        REAL_DB.ref(`onlineClass/${partSelected?.id}/${userDetails?.uid}`)
            .set(updates)
            // .then(() => {
            //     console.log('Updated...')
            // })
            .catch((er) => {
                setPaused(true)
                console.log('Error while updating : ', er)
            })
    }

    const calculatePercentage = () => {
        let percent = 0
        for (let i = 0, l = timeSpentRef.current.length; i < l; i++) {
            if (!!timeSpentRef.current[i]) percent++
        }

        calcPercentRef.current = Math.round(
            (percent / timeSpentRef.current.length) * 100
        )
        if (lastPercent.current === calcPercentRef.current) return

        lastPercent.current = calcPercentRef.current
        // console.log('Percentage : ', calcPercentRef.current)
        setDataToDB()
    }

    const checkElapsedTime = (data) => {
        if (lastSecondRef.current === parseInt(data.seconds)) return

        lastSecondRef.current = parseInt(data.seconds)

        if (!!!timeSpentRef.current.length) {
            for (let i = 0, l = parseInt(data.duration); i < l; i++)
                timeSpentRef.current.push(0)
        }
        timeSpentRef.current[parseInt(data.seconds)] = 1
        calculatePercentage()
    }

    function getFromDB() {
        setLoading(true)
        if (!!!partSelected?.id || !!!userDetails?.uid) return

        const dbRef = REAL_DB.ref(
            `onlineClass/${partSelected?.id}/${userDetails?.uid}`
        )
        dbRef.on('value', (snapshot) => {
            const data = snapshot.val()

            if (data !== null) {
                const videoDataArray = JSON.parse(data?.videoTimeChart)
                if (typeof videoDataArray === 'object') {
                    timeSpentRef.current = videoDataArray
                } else {
                    timeSpentRef.current = JSON.parse(videoDataArray)
                }

                setPercentageViewed(data?.percentage)
            } else {
                console.log('No data available')
            }
            setLoading(false)
        })
    }

    useEffect(() => {
        getFromDB()
    }, [partSelected, userDetails])

    if (
        !!!chapterSelected ||
        !!!subSelected ||
        !!!partSelected ||
        !!!userDetails
    )
        return <Redirect to={navDirections.ONLINE_CLASS} />

    return (
        <VideoWrapper>
            <ChapterName>{chapterSelected}</ChapterName>
            <Heading>
                {`PART ${
                    partSelected.Part < 10
                        ? `0${partSelected.Part}`
                        : partSelected.Part
                }`}
                <br />
                {partSelected.title || ''}
            </Heading>
            {(!ready || loading) && <ZoomingAnimation />}

            {!loading && (
                <VideoContainer>
                    <Vimeo
                        video={partSelected?.ytVideoID}
                        autoplay
                        onTimeUpdate={checkElapsedTime}
                        responsive={true}
                        paused={paused}
                        onReady={() => {
                            setReady(true)
                        }}
                    />
                </VideoContainer>
            )}

            {ready && (
                <p
                    style={{
                        color: '#fff',
                        textAlign: 'center',
                        marginTop: '40px'
                    }}
                >
                    You have watched
                </p>
            )}
            {ready && <ProgressBarVideo percentage={percentageViewed} />}
        </VideoWrapper>
    )
}

const ChapterName = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 10px;
    font-size: 18px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    margin: 30px 0;
    font-size: 18px;
    line-height: 150%;
`
const VideoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 30px;
`

const VideoContainer = styled.div`
    width: 100%;
    max-width: 600px;
`

export default OnlineClassYtVideo
